__webpack_require__.p = "/boletadigital/";